import React from "react"
import { Switch as AntSwitch } from "antd"
import { classNames } from "../../../utils/classNames"

export type SwitchProps = {
    checked?: boolean
    onChange?: (checked: boolean, event?: MouseEvent) => void
    disabled?: boolean
    indeterminate?: boolean
    size?: "small" | "default"
    children?: string | React.ReactNode
    className?: string
}

export const Switch = (props: SwitchProps) => {
    const { checked, indeterminate } = props
    const switchClass = indeterminate ? "third-state-switch" : null
    const isChecked = indeterminate || checked

    if (props.children) {
        return (
            <a
                className="inline-flex w-auto items-center text-inherit"
                onClick={() => props.onChange?.(!props.checked)}>
                <AntSwitch
                    checked={isChecked}
                    size={props.size}
                    disabled={props.disabled}
                    className={classNames(props.className, switchClass)}
                />
                <span className="ml-3 inline-block">{props.children}</span>
            </a>
        )
    }
    return (
        <AntSwitch
            checked={isChecked}
            size={props.size}
            onChange={props.onChange}
            disabled={props.disabled}
            className={classNames(props.className, switchClass)}
        />
    )
}
